module.exports = __webpack_public_path__ + "static/Montserrat-Regular-ee6539921d713482b8ccd4d0d23961bb.ttf";